import {useEffect, useState} from "react";
import {debounce} from "lodash";

export const useIsScreenSizeLargerThan = (width: number) => {
    const [isCurrentScreenLarger, setisCurrentScreenLarger] = useState(window.innerWidth > width);

    useEffect(() => {
        const handleResize = debounce(() => {
            setisCurrentScreenLarger(window.innerWidth > width);
        }, 50);

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [width]);

    return isCurrentScreenLarger;
};
